import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Equipment } from '../../../models/equipment';
import { Page } from '../../../models/paging/page';
import { Category } from '../../../models/category';
import { CompanyService } from '../../../services/company.service';
import { AuthService } from '../../../services/auth.service';
import { CategoryService } from '../../../services/category.service';
import { LocationService } from '../../../services/location.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { FilterService } from '../../../services/filter.service';
import { JobService } from '../../../services/job.service';
import { ConfirmationService } from "primeng/api";
import { SnotifyService } from 'ng-snotify';

@Component({
  selector: 'app-job-management',
  templateUrl: './job-management.component.html',
  styleUrls: ['./job-management.component.scss']
})


export class JobManagementComponent implements OnInit {
  filter: any = {
    company_Id: 0,
    location_Id: 0,
    technicianId: 0,
    job_Num: '',
    completed: -1
  };
 
  completed_Statuses: any = [{ Name: "All", Value: -1 }, { Name: "Uncompleted", Value: 0 }, { Name: "Completed", Value: 1 }];
  loading: boolean = false;
  default_filters = JSON.parse(JSON.stringify(this.filter));

  pageno: number;

  page = new Page();
  rows = Array<any>();
  equipAccess = false;
  user;
  constructor(public companyService: CompanyService, public locationService: LocationService, public categoryService: CategoryService,
    public jobService: JobService, public router: Router, private authService: AuthService, private filterService: FilterService,
    private confirmationService: ConfirmationService, private snotifyService: SnotifyService) {
    if (this.authService.currentUser.value.userProfileId != 1) {
      //user is a client, so throw them to the reports page
      this.router.navigate(['reports/rote']);
    }
    this.page.pageNumber = 0;
    this.page.size = 9999999;



    // Check if any filters are present
    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      this.loadTable(this.page)
    }
  }

  ngOnInit(): void {
   
  }

  onCompanyChange(value) {
    this.filter.locationId = 0;

    if (value == undefined)
      this.filter.companyId = undefined;
    else
      this.filter.companyId = value.id;

  }

  onLocationChange(value) {
    if (value == undefined)
      this.filter.locationId = undefined;
   else
    this.filter.locationId = value.id;

  }

  onTechnicanChange(value) {
    if (value == undefined)
      this.filter.technicianId = undefined;
   else
      this.filter.technicianId = value.id;

  }

  onCategoryChange(value) {
    if (value == undefined)
      this.filter.categoryId = undefined;
   else
      this.filter.categoryId = value.id;
  }
  edit(row) {
    //console.log(row);
    this.router.navigate(['admin/jobs/manage'], { queryParams: { id: row.id } });
  }
  complete(row) {
    //console.log(row);

    this.confirmationService.confirm({
      message: 'Are you sure that you want approve this job?',
      accept: () => {
        this.jobService.approve(row.id, this.authService.currentUser.value.id).then(() => {
          this.snotifyService.success("Successfully Approved Job");
          this.loadTable(this.page);
        });
      }
    });  }

  add() {
    this.router.navigate(['admin/jobs/manage']);
  }

  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.loadTable(this.page);
  }

  rebind() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.loading = true;
    //console.log(this.filter.completed);
    this.filterService.saveFilters(this.authService.currentUser.value.id, this.router.url, this.filter);
    this.jobService.getResults(this.page, this.filter.companyId, this.filter.locationId, this.filter.completed,
      this.filter.technicianId, this.filter.job_Num).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      //console.log(this.rows);
      this.loading = false;
    }, (rejected) => {
      //console.log(rejected);
      this.loading = false;
    });
  }

  generateExcel() {

    this.jobService.getExcel(this.filter.companyId, this.filter.locationId).then((data) => {
      importedSaveAs(data, 'Jobs.xlsx');
    });
  }

}
